import { SocialAuthService } from '@abacritt/angularx-social-login';
import { Directive, ElementRef, Input, OnInit } from '@angular/core';
import { take } from 'rxjs';

declare var google;

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: 'google-signin-btn',
})
export class GoogleSigninButtDirective implements OnInit {
  @Input() option: boolean;

  constructor(private el: ElementRef, private socialAuthService: SocialAuthService) {}

  ngOnInit() {
    this.socialAuthService.initState.pipe(take(1)).subscribe(() => {
      google.accounts.id.renderButton(this.el.nativeElement, {
        type: 'standard',
        logo_alignment: 'center',
        size: 'large',
        text: 'signin_with',
        theme: 'outline',
      });
    });
  }
}
